<template>
  <section class="shop-pos">
    <div class="topDiv">
      <Form ref="searchForm" :model="searchForm" inline :label-width="0">
        <Row>
          <Col span="24">
            <FormItem prop="status">
              <Select
                filterable
                v-model="searchForm.status"
                placeholder="请选择状态"
                style="width: 200px"
              >
                <Option
                  :key="index"
                  :value="item.value"
                  v-for="(item, index) in statusList"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem>
              <Input
                type="text"
                v-model="searchForm.searchKeyStr"
                clearable
                placeholder="门店名称/手机号/账号/联系人"
                style="width: 200px"
              />
            </FormItem>
            <FormItem>
              <Select
                filterable
                v-model="searchForm.dealerCode"
                placeholder="请选择运营方"
                style="width: 200px"
              >
                <Option
                  :key="index"
                  :value="item.code"
                  v-for="(item, index) in categoryAllList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleSearch"
                type="primary"
                icon="ios-search"
                v-access="'shopTask.shopPos.query'"
                >搜索</Button
              >
              <Button
                @click="handleReset"
                style="margin-left: 10px"
                v-access="'shopTask.shopPos.reset'"
                >重置</Button
              >
            </FormItem>
          </Col>
        </Row>

        <Row>
          <FormItem prop="dealerCode">
            <Select
              filterable
              v-model="searchForm.dealerCode"
              placeholder="请选择经销商"
              style="width: 200px"
            >
              <Option
                :key="index"
                :value="item.code"
                v-for="(item, index) in spInfoQueryAll"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem prop="month">
            <DatePicker
              type="month"
              placeholder="请选择月份"
              style="width: 200px"
              format="yyyy-MM"
              v-model="searchForm.month"
            ></DatePicker>
          </FormItem>
        </Row>
      </Form>
    </div>

    <div class="bigbox">
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="dataSource"
        ref="table"
      ></Table>

      <Row type="flex" justify="end" class="page" style="margin-top: 10px">
        <Page
          :current="searchForm.page"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        >
        </Page>
      </Row>
    </div>

    <Modal
      v-model="examineDisable"
      @on-ok="handleConfirm"
      @on-cancel="handleCancel"
    >
      <Form
        ref="examineSearchForm"
        :model="examineSearchForm"
        inline
        :label-width="100"
      >
        <Row>
          <FormItem prop="examineStatus" label="审核">
            <RadioGroup v-model="examineSearchForm.examineStatus">
              <Radio label="20">
                <span>通过</span>
              </Radio>
              <Radio label="10">
                <span>拒绝</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="examineRemark" label="备注">
            <Input
              type="text"
              v-model="searchForm.examineRemark"
              clearable
              placeholder="请输入备注"
              style="width: 200px"
            />
          </FormItem>
        </Row>
      </Form>
    </Modal>
  </section>
</template>

<script>
export default {
  name: "shopDisplay",
  data() {
    return {
      total: 0,
      loading: false,
      examineDisable: false,
      dataSource: [],
      spInfoQueryAll: [],
      categoryAllList: [],
      statusList: [
        { label: "全部", value: "" },
        { label: "待审核", value: "1" },
        { label: "审核通过", value: "20" },
        { label: "审核拒绝", value: "10" },
        { label: "已作废", value: "-255" },
      ],
      examineInfo: {},
      searchForm: {
        page: 1,
        pageSize: 10,
        month: "",
      },
      examineSearchForm: {
        examineStatus: "10",
        examineRemark: "",
      },
      ruleValidate: {
        examineStatus: [
          { required: true, message: "请选择平台编码", trigger: "change" },
        ],
      },
      columns: [
        {
          title: "序号",
          type: "index",
          minWidth: 30,
          fixed: "left",
        },
        {
          title: "门店ID",
          key: "id",
          minWidth: 80,
          fixed: "left",
        },
        {
          title: "名称",
          key: "retName",
          minWidth: 160,
          fixed: "left",
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h(
                "a",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => this.handleOpenDetail(row.id),
                  },
                },
                row.retName
              ),
            ]);
          },
        },
        {
          title: "账号",
          key: "loginAccount",
          minWidth: 100,
        },
        {
          title: "联系人",
          key: "contactPerson",
          minWidth: 100,
        },
        {
          title: "关联经销商",
          key: "spName",
          minWidth: 160,
        },
        /* {
          title: "陈列数量",
          key: "loginAccount",
          minWidth: 100,
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h(
                "div",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  }
                },
                row.loginAccount.length
              )
            ]);
          }
        }, */
        {
          title: "所属月份",
          key: "billMonth",
          minWidth: 100,
        },
        {
          title: "状态",
          key: "status",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const { row } = params;
            return h(
              "div",
              {
                directives: [
                  {
                    name: "access",
                    value: "shopTask.shopPos.status",
                  },
                ],
                props: {
                  type: "primary",
                  size: "small",
                },
              },
              this.switchStatus(row.status)
            );
          },
        },
        {
          title: "操作",
          key: "retCode",
          width: 120,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              row.status == "1"
                ? h(
                    "a",
                    {
                      directives: [
                        {
                          name: "access",
                          value: "shopTask.shopPos.edit",
                        },
                      ],
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => this.handleOpenModel(row),
                      },
                    },
                    "审核"
                  )
                : null,
            ]);
          },
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getSpInfoQueryAll();
      this.getPosQueryList(this.searchForm);
    },
    async getSpInfoQueryAll() {
      const { data } = await this.$api["spInfoQueryAll"]();
      this.spInfoQueryAll = data;
    },
    async getPosQueryList(params = {}) {
      const { data, total } = await this.$api["posQueryList"](params);
      this.dataSource = data;
      this.total = total;
    },
    switchStatus(status) {
      switch (status) {
        case "1":
          return "待审核";
        case "20":
          return "审核通过";
        case "10":
          return "审核拒绝";
        case "-255":
          return "已作废";
      }
    },
    yyyymm: function (d) {
      if (!d) {
        return "";
      }
      let str = new Date(d);
      let y = String(str.getFullYear());
      let m = String(str.getMonth() + 1);
      if (m.length == 1) {
        m = "0" + m;
      }
      return y + "-" + m;
    },
    handleSearch() {
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      const params = {
        ...this.searchForm,
        month: this.searchForm.month ? this.yyyymm(this.searchForm.month) : "",
      };
      this.searchForm = params;
      this.getPosQueryList(params);
    },
    async handleConfirm() {
      const { id } = this.examineInfo;
      const params = {
        id: id,
        ...this.examineSearchForm,
        status: this.examineSearchForm.examineStatus || "",
      };
      delete params.examineStatus;
      const { data, code } = await this.$api["posExamine"](params);
      if (code == "200") {
        this.$Message.success("审核成功");
        this.getPosQueryList(this.searchForm);
      }
    },
    handleCancel() {
      this.examineSearchForm = {
        examineStatus: "10",
        examineRemark: "",
      };
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      this.searchForm.id = "";
      this.searchForm.month = "";
      this.searchForm.status = "";
      this.searchForm.queryString = "";
      this.searchForm.spCode = "";
      this.getPosQueryList();
    },
    handleOpenModel(row) {
      this.examineInfo = row;
      this.examineSearchForm.examineStatus = "10";
      this.examineDisable = true;
    },
    handleOpenDetail(v) {
      this.$router.push({
        path: "/shopTask/shopPos/detail",
        query: {
          id: v,
        },
      });
    },
    changePage(v) {
      this.searchForm.page = v;
      this.getPosQueryList(this.searchForm);
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getPosQueryList(this.searchForm);
    },
  },
};
</script>

<style scoped>
.shop-pos {
  background: #f0f2f5;
  margin: -24px -20px;
  height: 100%;
}
.shop-pos .topDiv {
  padding: 24px 24px 0;
  background: #fff;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0px 0px 6px 0px #e2e2f8;
  border-radius: 8px;
}
.shop-pos .bigbox {
  background: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 24px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/shopTask/shopPos.vue